/* eslint-disable quotes */
export default {
  AWAY_TIME: 'ó',
  COMMON__MINUTES: 'p',
  SENDBIRD: {
    BADGE__OVER: '+',
    MESSAGE_MENU__EDIT: 'Szerkesztés',
    BUTTON__DELETE: 'Törlés',
    MESSAGE_STATUS__DELETE: 'Törlés',
    MESSAGE_MENU__DELETE: 'Törlés',
    BUTTON__SAVE: 'Mentés',
    BUTTON__CLOSE: 'Zárja',
    BUTTON__CANCEL: 'Bezár',
    CHANNEL_SETTING__PROFILE__EDIT: 'Szerkesztés',
    MESSAGE_INPUT__PLACE_HOLDER: 'Enter',
    MODAL__CHANNEL_INFORMATION__UPLOAD: 'Feltöltés',
    EDIT_PROFILE__IMAGE_UPLOAD: 'Feltöltés',
    CHANNEL_LIST__TITLE: 'Csatorna',
    MESSAGE_MENU__COPY: 'Másol',
    CHANNEL_SETTING__HEADER__TITLE: 'Csatorna információ',
    MODAL__USER_LIST__TITLE: 'Tagok',
    CHANNEL_SETTING__MEMBERS__TITLE: 'Tagok',
    NO_MEMBERS: '(Nincsenek tagok)',
    NO_NAME: '(Nincs név)',
    TOOLTIP__UNKOWN_USER: '(Nincs név)',
    CHANNEL_SETTING__LEAVE_CHANNEL__TITLE: 'Csatorna elhagyása',
    BUTTON__INVITE: 'Meghív',
    MODAL__INVITE_MEMBER__SELECTED: 'Kiválasztott',
    MODAL__CREATE_CHANNEL__SELECTED: 'Kiválasztott',
    MODAL__CHANNEL_INFORMATION__CHANNEL_NAME: 'Csatorna neve',
    MODAL__INVITE_MEMBER__TITLE: 'Tagok meghívása',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER: 'Enter',
    BUTTON__CREATE: 'Készít',
    MODAL__CREATE_CHANNEL__TITLE: 'Új csatorna',
    TRYING_TO_CONNECT: 'Csatlakozás megkísérlése',
    USER_PROFILE__MESSAGE: 'Üzenet',
    USER_PROFILE__USER_ID: 'Felhasználói ID',
    EDIT_PROFILE__USERID_LABEL: 'Felhasználói ID',
    EDIT_PROFILE__TITLE: 'Profilom',
    EDIT_PROFILE__IMAGE_LABEL: 'Profilkép',
    EDIT_PROFILE__NICKNAME_LABEL: 'Becenév',
    EDIT_PROFILE__THEME_LABEL: 'Sötét téma',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER__DISABLED: 'A csevegés nem elérhető ezen a csatornán',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE: 'Új üzenet(ek)',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__ON: 'be',
    CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS: 'Összes tag',
    CHANNEL_SETTING__MEMBERS__INVITE_MEMBER: 'Felhasználók meghívása',
    MODAL__DELETE_MESSAGE__TITLE: 'Üzenet törlése?',
    MODAL__CHANNEL_INFORMATION__TITLE: 'Csatorna információjának szerkesztése',
    MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE: 'Csatorna képe',
    MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER: 'Név hozzáadása',
    TYPING_INDICATOR__IS_TYPING: 'gépel...',
    TYPING_INDICATOR__ARE_TYPING: 'gépel...',
    TYPING_INDICATOR__MULTIPLE_TYPING: 'gépel...',
    TYPING_INDICATOR__AND: 'és',
    MESSAGE_STATUS__SENDING_FAILED: 'Üzenet elküldése sikertelen.',
    MESSAGE_STATUS__TRY_AGAIN: 'Próbálja újra.',
    MESSAGE_STATUS__OR: 'vagy',
    PLACE_HOLDER__WRONG: 'Valami hiba történt.',
    PLACE_HOLDER__RETRY_TO_CONNECT: 'Újrapróbál',
    NO_TITLE: 'Nincs téma',
    TOOLTIP__AND_YOU: ', és te',
    TOOLTIP__YOU: 'Ön',
    UNKNOWN__UNKNOWN_MESSAGE_TYPE: '(Ismeretlen üzenettípus)',
    UNKNOWN__CANNOT_READ_MESSAGE: 'Nem lehet elolvasni ezt az üzenetet.',
    MESSAGE_EDITED: '(szerkesztve)',
    PLACE_HOLDER__NO_CHANNEL: 'Új beszélgetés indítása',
    MESSAGE_MENU__REPLY: 'Válasz',
    QUOTED_MESSAGE__REPLIED_TO: '→',
    QUOTE_MESSAGE_INPUT__REPLY_TO: '',
    QUOTED_MESSAGE__CURRENT_USER: 'Ön',
    MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER: 'Válasz az üzenetre',
  },
  TERMS_IMPRESSUM: 'Impressum',
  TERMS_DATENSCHUTZ: 'Datenschutz',
  CONFIRM: 'OK',
  SETTINGS__NONE: 'Nincs',
  SEARCH__NO_RESULT: 'Nincs keresési eredmény',
  LOGIN__PASSWORD: 'Jelszó',
  SEARCH__USER_PLACEHOLDER: 'Név/Munkavállalói szám/Telefonszám',
  BASIC__: {
    HAS_ATTENDANCE_HISTORY_VIEW_RIGHT: 'Személyes jelenléti ív megtekintésére jogosult?',
    ERROR: 'Hiba történt. <br /> Kérjük, próbálja meg később újra.',
    MSG__: { INPUT: 'Keresés kulcsszó alapján' },
    PWD_ALL_VALIDATION:
      'A jelszónak %1$@~%2$@ nagy- és kisbetű, számok és speciális karakterek kombinációjából kell állnia.',
    RETRY: 'Újrapróbál',
    PASSWORD_RULE: '8-20 karakter, ami betűket, számokat és szimbólumokat is kell, hogy tartalmazzon.',
  },
  SEARCH__NO_USER_INFO: 'Nincs felhasználói információ.',
  LOGIN__EMAIL_OR_HP: 'E-mail/telefonszám',
  BASIC__SEARCH: 'Keresés',
  ELECTRON: {
    MENU_DELETE: 'Törlés',
    MENU_VIEW: 'Megtekintés',
    MENU_SIGN_OUT: 'Kijelentkezés',
    MENU_SETTINGS: 'Beállítások',
    MENU_CLOSE: 'Zárja',
    MENU_EDIT: 'Szerkesztés',
    MENU_SELECT_ALL: 'Mindenki kiválasztása',
    MENU_COPY: 'Másol',
    MENU_FILE: 'Fájlok',
    MENU_ABOUT: '{0}-ról',
    MENU_UPDATE: 'Frissítés ellenőrzése',
    MENU_HIDE: 'Elrejt {0}',
    MENU_HIDE_OTHERS: 'Mások elrejtése',
    MENU_SHOW_ALL: 'Összes megjelenítése',
    MENU_QUIT: 'Kilép {0}',
    MENU_NEW_CHANNEL: 'Új csatorna',
    MENU_UNDO: 'Visszavonás',
    MENU_REDO: 'Újraindít',
    MENU_CUT: 'Kivág',
    MENU_PASTE: 'Beilleszt',
    MENU_PASTE_AND_MATCH_STYLE: 'Beillesztés stílusa',
    MENU_RELOAD: 'Újratölt',
    MENU_FORCE_RELOAD: 'Újratöltésre kényszerítés',
    MENU_FULL_SCREEN: 'Teljes képernyő átkapcsolása',
    MENU_RESET_ZOOM: 'Aktuális méret',
    MENU_ZOOM_IN: 'Ráközelít',
    MENU_ZOOM_OUT: 'Kicsinyítés',
    MENU_WINDOW: 'Ablak',
    MENU_MINIMIZE: 'Minimalizál',
    MENU_ZOOM: 'Zoom',
    MENU_HELP: 'Súgó',
    MESSAGE_UP_TO_DATE: 'Jelenleg a legújabb verziót használja.',
    UPDATE_AVAILABLE: 'Frissítés rendelkezésre áll',
    MESSAGE_UPDATE_AVAILABLE: 'Elérhető a legújabb verzióra való frissítés.',
    UP_TO_DATE: 'Legújabb ver.',
  },
  LOGIN__INSERT_EMAIL_HP: 'Adja meg az e-mail címet vagy telefonszámot.',
  LOGIN__PASSWORD_GUIDE_SUBTITLE:
    'Ha elfelejtette jelszavát, kérjük, állítsa vissza azt a mobilalkalmazás bejelentkezési oldalán.',
  LOGIN__INSERT_PASSWORD: 'Kérjük, adja meg a jelszót',
  LOGIN__PASSWORD_INFORMATION: 'Elfelejtette jelszavát?',
  BEFORE: 'Mielőtt',
  ALERT__NO_ONE_SELECTED: 'Nincs kiválasztott alkalmazott.',
  LOGOUT: 'Kijelentkezés',
  LOGIN: 'Bejelentkezés',
  COMMON__SECONDS: 'másodperc(ek)',
  SCHEDULE__: {
    GUIDE__: {
      IF_YOU_STOP_UNSAVED: 'Ha abbahagyja a szerkesztést, a módosítások nem kerülnek mentésre.',
      ARE_YOU_SURE_WANT_TO_STOP: 'Biztos, hogy abba akarja hagyni a beosztás szerkesztését?',
    },
  },
  TEMPLATE__: {
    GUIDE__: { NO_TEMPLATE_REGISTERED: 'Nincs regisztrált sablon' },
  },
  SETTINGS__CHANGE_LANGUAGE: 'Nyelv',
  SEARCH__MEMBER_PLACEHOLDER: 'Név/munkavállalói szám/telefonszám',
  MSG__: {
    BASIC__: { NO_SEARCH_RESULT: 'Nincs eredmény.' },
    ERROR__: {
      CREATE_CHANNEL: 'Sikertelen csatorna készítés.',
      UPDATE_CHANNEL_INFO: 'Sikertelen csatorna frissítés.',
      LEAVE_CHANNEL: 'Sikertelen csatorna elhagyás.',
    },
    FILE__: { MAXIMGSIZE: 'A fájlméret korlátját túllépte.' },
    ALLOW_BROWSER_ALARM: 'Engedélyezze az értesítéseket a böngésző beállításában, hogy értesítéseket kapjon',
    LABEL__: { SEARCH_MESSAGE: 'Üzenetek keresése' },
    GUIDE__: { SEARCH_MESSAGE: 'Keressen rá az üzenetre a {0} csatornában.' },
  },
  BASIC__UNKNOWN: 'Ismeretlen',
  LOGIN__SERVER_ALERT: 'A szerverhez nem lehetett kapcsolódni.',
  INVITE__MEMBER_SELECTION: 'Tagok kiválasztása',
  CHANNEL__EDIT_CHANNEL_NAME_GUIDE: 'A megváltozott név minden csatorna résztvevője számára látható lesz.',
  NOTICE: 'Értesítések',
  INVITE__CREATE: 'Készít',
  CHANNEL__LEAVE_THIS_CHANNEL: 'Csatorna elhagyása?',
  LOGIN__PASSWORD_FAIL_COUNT: 'Ön rossz jelszót adott meg {0} alkalommal.',
  LOGIN__FAIL_ALERT: '5 egymást követő hibás próbálkozás után 5 percre zárolásra kerül.',
  LOGIN__LOCK_STATE_ALERT: '5 percre zárolták egymást követő rossz jelszókísérletek miatt.',
  LOGIN__RETRY_ALERT: 'Kérjük, próbálja meg újra {0}.',
  LOGIN__PASSWORD_GUIDE_TITLE: 'A ShoplChat jelszava megegyezik a mobilalkalmazás jelszavával.',
  SETTINGS__ALL_MESSAGES: 'Értesítések minden új üzenetről',
  SETTINGS__ALARM_SOUND: 'Hang',
  SETTINGS__SOUND_ALARM: 'Értesítő hang',
  SETTINGS__LISTEN_ALARM_SOUND: 'Hallgat',
  ALERT__MAX_INVITE_MEMBER: 'A csatornához legfeljebb 20 000 ember csatlakozhat.',
  LOGIN__DEACTIVATED_ALERT: 'Nem tud bejelentkezni, mivel a rendszergazda kikapcsolta a chat funkciót.',
  LOGIN__SERVER_ALERT_CONTENTS:
    'Instabil hálózat miatt nem lehet bejelentkezni. Kérjük, ellenőrizze a hálózati kapcsolatot, és próbálja meg újra.',
  LOGIN__LOGOUT_ALERT: 'Ön ki lett jelentkeztetve.',
  CHANNEL__EDIT_CHANNEL_NAME: 'Csatorna nevének megváltoztatása',
  SETTINGS__THEME: 'Téma',
  SETTINGS__LANGUAGE: 'Nyelv',
  SETTINGS__LIGHT_THEME: 'Világos',
  SETTINGS__DARK_THEME: 'Sötét',
  SEARCH__CHANNEL_PLACEHOLDER: 'Munkavállaló neve',
  CHANNEL__CONTACT: '1:1 chat',
  BASIC: { LABEL: { MAXIMAGECNT: 'Legfeljebb {0} képet lehet feltölteni.' } },
  LOGIN__LOGIN_FAILED: 'Helytelen azonosító vagy jelszó.',
  FORGOT_PW: 'Elfelejtette jelszavát?',
  BASIC__MAX_FORMAT_INPUT: 'Max. %@ karakterek adhatók meg.',
  SERVICE__COMING_SOON: 'Nem sokára',
  LOGIN__GUIDE: 'Az alkalmazásban használt fiókkal jelentkezhet be.',
  MOBILE__: {
    ACCESS_PC: 'A műszerfal elérése PC-ről!',
    ACCESS_DESC_01: 'A műszerfal PC-környezethez van optimalizálva.',
    ACCESS_DESC_02: 'A legjobb élmény érdekében próbálja meg a hozzáférést egy PC-ről.',
    ACCESS_PC_ONLY: 'Próbálja meg a hozzáférést a számítógépről!',
    GUIDE: 'A csevegés funkció elérhető a számítógépen vagy a mobilalkalmazáson.',
  },
  CHANNEL__NO_CHAT_HISTORY: 'Nincsenek beszélgetések',
};
